import { View, Text } from 'react-native'
import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Button } from '@/src/common/components/Button'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'
import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'
import { CardApplicationWrapper } from './cardApplicationWrapper'
import { typography } from '@/src/common/theme'
import { cardApplicationStyles as commonStyle } from './common'

export function ApplicationDenied() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-denied' })
  }, [updateOptions])

  useDisableSwipingBackToThePreviousPage()
  return (
    <CardApplicationWrapper>
      <View style={commonStyle.headerText}>
        <Text style={typography['heading/heading2']}>
          Your application is not approved at this time
        </Text>
      </View>
      <Text style={commonStyle.instructionText}>
        We are unable to approve your application at this time. We understand that this may not be
        the decision you were expecting. You will receive a notification from us advising you of the
        reasons for decline. Please try again in 30 days.
      </Text>
      <View style={{ flex: 1 }} />
      <View style={{ marginBottom: 0, gap: 10 }}>
        <Button title="Return Home" onPress={() => router.replace(Routes.Main.route)} />
      </View>
    </CardApplicationWrapper>
  )
}
